import React from "react";
import { useTranslation } from "react-i18next";
import { IconPercentage } from "@tabler/icons-react";

import "./styles.scss";

import { Card, Text } from "@fragments";
import Parser from "@helpers/parser.js";
import { WALLET_PROVIDERS } from "@helpers/wallets";

export default function Taxes({
    provider,
    wallet,
    loading,
}) {
    const { t } = useTranslation("banking");
    const activeProvider = provider || wallet?.provider || WALLET_PROVIDERS.ASAAS;
    const isStripe = activeProvider === WALLET_PROVIDERS.STRIPE;
    const currency = wallet?.currency || (isStripe ? 'USD' : 'BRL');

    if (loading) {
        return (
            <Card
                flat
                className="withdrawals-taxes-card"
                title={t("withdrawals.taxes.title")}
                subtitle={t("withdrawals.taxes.subtitleLoading")}
                icon={<IconPercentage />}
            >
                <div className="taxes-card taxes-card--loading">
                    <div className="left-section">
                        <IconPercentage className="taxes-icon" />
                    </div>
                    <div className="right-section">
                        <Text.label loading contrast={8}>{t("withdrawals.taxes.loadingLabel")}</Text.label>
                        <Text.span loading contrast={6}>{t("withdrawals.taxes.loadingValue")}</Text.span>
                    </div>
                </div>
            </Card>
        );
    }

    if (!wallet?.taxes && !isStripe) return null;

    const taxes = wallet?.taxes;

    return (
        <Card
            flat
            className="withdrawals-taxes-card"
            title={t("withdrawals.taxes.title")}
            subtitle={isStripe
                ? t("withdrawals.taxes.subtitleStripe")
                : t("withdrawals.taxes.subtitleAsaas")}
            icon={<IconPercentage />}
        >
            {taxes ? (
                <div className="taxes-card">
                    <div className="left-section">
                        <IconPercentage className="taxes-icon" />
                    </div>

                    <div className="right-section">
                        <div className="info-row">
                            <Text.span contrast={7}>
                                {t("withdrawals.taxes.saleFee")}
                            </Text.span>
                            <Text.label contrast={9}>
                                {taxes.percentile}% + {Parser.price.format(taxes.fixed, currency)}
                            </Text.label>
                        </div>

                        {!isStripe && (
                            <div className="info-row">
                                <Text.span contrast={7}>
                                    {t("withdrawals.taxes.installmentFee")}
                                </Text.span>
                                <Text.label contrast={9}>
                                    {taxes.anticipation}%
                                </Text.label>
                                <Text.span contrast={7}>
                                    {t("withdrawals.taxes.installmentSuffix")}
                                </Text.span>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="taxes-card taxes-card--empty">
                    <div className="left-section">
                        <IconPercentage className="taxes-icon" />
                    </div>
                    <div className="right-section">
                        <Text.label contrast={8}>{t("withdrawals.taxes.internationalTitle")}</Text.label>
                        <Text.span contrast={6}>
                            {t("withdrawals.taxes.internationalDescription")}
                        </Text.span>
                    </div>
                </div>
            )}
        </Card>
    );
}
